import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import Table from '../Table/Table';
import { getKindTickets } from '../../api/axios';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Checkbox } from '@mui/material';

const KindTickets = () => {
  const { t } = useTranslation('global');

  const [loading, setLoading] = useState(true);
  const [kindTickets, setKindTickets] = useState([]);
  const [showNames, setShowNames] = useState(true);
  const location = useLocation();
  const { startDate, endDate, selectedOption } = location.state || {};

  useEffect(() => {
    const retreiveInfo = async () => {
        const response = await getKindTickets(startDate, endDate, selectedOption);
        setKindTickets(response);
        setLoading(false);
    };

    retreiveInfo();
  }, []);

  const column = [
    {heading: t("reports.category"), value: "category"},
    {heading: t("reports.name"), value: "name"},
    {heading: t("reports.surname"), value: "surname"},
    {heading: t("reports.phone"), value: "phone"},
    {heading: t("reports.type"), value: "type"},
    {heading: t("reports.kind"), value: "kind"},
    {heading: t("reports.price"), value: "price"},
    {heading: t("reports.from"), value: "time_from"},
    {heading: t("reports.until"), value: "time_to"},
    {heading: t("reports.fromDate"), value: "date_from"},
    {heading: t("reports.untilDate"), value: "date_to"},
    {heading: t("reports.dateCreated"), value: "date"},
    {heading: t("reports.timeCreated"), value: "time"},
    {heading: t("reports.PDV"), value: "vat"},
    {heading: t("reports.ticketAgent"), value: "log_card"},
    {heading: t("reports.paymentMethod"), value: "payment_method"},
    {heading: t("reports.QR"), value: "qr_code"},
  ];

  const filteredColumns = column.filter(col => {
    if (col.value === 'name' || col.value === 'surname' || col.value === 'phone') {
      return showNames;
    }
    return true;
  });

  return (
    <div>
      <h2>{selectedOption}</h2>
      <FormControlLabel
      sx={{margin: 1}}
        control={
          <Checkbox
            checked={showNames}
            onChange={(e) => setShowNames(e.target.checked)}
          />
        }
        label={t("reports.show_names")}
      />
      
      { loading ? (<p>{t("reports.loading")}</p>) : (
        <Table data={kindTickets} column={filteredColumns}/>
        
      ) }
    </div>
  )
}

export default KindTickets
